import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

/** #1280: unlike window.confirm this is visible within the browser document. */
export default function QuickTrainerConfirmDialog({ open, title, description, confirmLabel, confirmColor = "primary", busy = false, onCancel, onConfirm }) {
  return <Dialog open={Boolean(open)} onClose={busy ? undefined : onCancel} aria-labelledby="quick-confirm-title" aria-describedby="quick-confirm-details" maxWidth="sm" fullWidth>
    <DialogTitle id="quick-confirm-title">{title}</DialogTitle>
    <DialogContent><DialogContentText id="quick-confirm-details">{description}</DialogContentText></DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={busy}>Cancel — no changes</Button>
      <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={busy}>{confirmLabel}</Button>
    </DialogActions>
  </Dialog>;
}
